import {
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_SELECT_SURVEY,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_CLOSE_ERROR,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_UPDATE_DATA_CUTS,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_SUCCESS,
  SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_INIT
} from '../actions/ReviewDataCutsActions';

export const initialState = {
  searchSurveyText: '',
  searchDataCutText: '',
  //  This is intended to capture the total count since all might not be in view
  searchedSurveyCount: 5,
  //  TODO: We should track pagination settings somewhere such as this
  searchSurveyParams: {
    offset: 0,
    limit: 100
  },
  surveys: [
    {
      pub_survey_short_name: 'ABA Compensation & Benefits, 2018',
      survey_code: 'ABA-18'
    },
    {
      pub_survey_short_name: 'AWS Test svy',
      survey_code: 'AWS-TEST18'
    },
    {
      pub_survey_short_name: 'CompData Benchmark Pro - National, 2016',
      survey_code: 'COMPD-BEN16'
    },
    {
      pub_survey_short_name: 'Culpepper Operations, 2017',
      survey_code: 'CUL-OPS17'
    },
    {
      pub_survey_short_name:
        'Aon Hewitt TCM Executive & Senior Mgmt Total Comp by Industry Full Value LTI, 2017 Aon Hewitt TCM Executive & Senior Mgmt Total Comp by Industry Full Value LTI, 2017',
      survey_code: 'HEW-EXE-T17'
    }
  ],
  selectedSurveyCode: 'HEW-EXE-T17',
  selectedSurveyDataCuts: [
    {
      currency: 'USD',
      job_scope: 'National',
      job_scope_checked: true,
      priority_level: 3,
      unique_identifier: '51c2d00624c9c3d15b384a4d66f91f7e'
    },
    {
      currency: 'CAN',
      job_scope: 'National; Org Wgtd',
      job_scope_checked: true,
      priority_level: 1,
      unique_identifier: '2688260bc5c79aa0e63f446e4d7ba9dd'
    },
    {
      currency: 'USD',
      job_scope: 'National; Gross Revenue (Millions): $3000.0+',
      job_scope_checked: false,
      priority_level: null,
      unique_identifier: '0c0394820d72e872879a94f191f5e2e5'
    },
    {
      currency: 'CAN',
      job_scope: 'National; Industry: Hospitality; Org Wgtd',
      job_scope_checked: false,
      priority_level: null,
      unique_identifier: 'e28c87f9231e8851a0af9f0356644824'
    },
    {
      currency: 'USD',
      job_scope: 'National; Industry: Insurance; Org Wgtd',
      job_scope_checked: false,
      priority_level: null,
      unique_identifier: '8bcefb614c59337e8f3323d53818685a'
    }
  ],
  loadingSurveys: false,
  loadingDataCuts: false,
  hasError: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_SELECT_SURVEY:
      return {
        ...state,
        selectedSurveyCode: action.payload
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_CLOSE_ERROR:
      return {
        ...state,
        hasError: false
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_SURVEYS_SEARCH:
      return {
        ...state,
        searchSurveyText: action.payload
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_CHANGE_DATA_CUT_SEARCH:
      return {
        ...state,
        searchDataCutText: action.payload
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_UPDATE_DATA_CUTS:
      return {
        ...state,
        selectedSurveyDataCuts: action.payload
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_INIT:
      return {
        ...state,
        loadingSurveys: true
      };
    case SURVEY_MIGRATION_REVIEW_DATA_CUTS_GET_SURVEYS_SUCCESS:
      return {
        ...state,
        loadingSurveys: false,
        surveys: action.payload.surveys,
        searchedSurveyCount: action.payload.totalCount
        //  TODO: Update the selected survey to index 0 if the current survey code does not exist
      };
    default:
      return state;
  }
}
